import { createStyles } from '@material-ui/styles'
import { ThemeType } from 'theme'

export const introPageStyles = (theme: ThemeType) =>
  createStyles({
    container: {
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
    },
    containerImageBg: {
      animation: '$move 20s ease-in-out',
      position: 'absolute',
      zIndex: 1,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100vw',
      height: '100vh',
      objectFit: 'cover',
      pointerEvents: 'none',
    },
    containerBg: {
      position: 'absolute',
      zIndex: 3,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100vw',
      height: '100vh',
      objectFit: 'cover',
      pointerEvents: 'none',
    },
    '@keyframes move': {
      '0%': {
        transformOrigin: 'center center',
        transform: 'scale(1.0) translate(0,0)',
      },
      '33%': {
        transform: 'scale(1.15) translate(60px, 35px)',
      },
      '100%': {
        transform: 'scale(1.0) translate(0,0)',
      },
    },
    content: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBottom: '12vh',
    },
    fogBg: {
      maxWidth: 1100,
      width: '100vw',
      position: 'absolute',
      zIndex: 2,
      transform: 'translateY(-10%)',
    },
    title: {
      fontSize: '3.6rem',
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
      lineHeight: 1,
      color: theme.palette.primary.main,
      position: 'relative',
      zIndex: 4,
      fontWeight: 300,
      letterSpacing: '5.63px',
      '& strong': {
        fontWeight: 900,
      },
    },
    'secondary-title-wrapper': {
      display: 'flex',
      justifyContent: 'flex-end',
      maxWidth: 400,
      width: '100%',
    },
    'secondary-title': {
      fontSize: '1.4rem',
      letterSpacing: '0.3px',
      color: theme.palette.secondary.main,
      marginBottom: '1rem',
      position: 'relative',
      zIndex: 4,
      textAlign: 'right',
      maxWidth: 250,
    },
    'intro-next-button': {
      marginTop: '15vh',
    },
  })
